<template>
  <footer v-if="showSave || !hideSaveAndMoveNext" class="card-footer" :class="buttonPosition === 'right' ? 'button-align-right' : ''">
    <o-loading :active="isLoading"></o-loading>
    <div class="has-text-black" v-if="!showSave">
      <button
        class="button has-background-black-bis has-text-white mr-3"
        @click="saveAndMoveNext"
        v-if="!hideSaveAndMoveNext && !['manager-edit-qa', 'cut-edit-manufacturing'].includes($store.state.activeScreen)"
        :disabled="isDisabled"
      >
       {{ moveButtonName }}
      </button>
      <button
        class="button is-success has-text-white"
        @click="createShipmentModal(card)"
        v-if="isCreateShipping && $store.state.activeScreen !== 'cut-edit-manufacturing'"
        :disabled="isShippingDisabled"
      >
        Create Shipment
      </button>
      <button
        class="button is-success has-text-white"
        @click="moveToKit(card)"
        v-if="isAssembly"
      >
        Move to Kit Location
      </button>
      <button
        class="button is-invent-btn has-text-white"
        @click="moveItemsToInventory"
        v-if="card.isCutOrder && $store.state.activeScreen === 'cut-edit-manufacturing'"
        :disabled="!isItemsCompleted"
      >
        Move Completed Items To Inventory
      </button>
    </div>
    <div v-else-if="$store.state.activeScreen === 'bimplus-additems'" class="buttons mr-3">
      <button @click="$emit('backToCardEditView')" class="button is-outlined">
        Cancel
      </button>
      <button class="button has-background-black-bis has-text-white" @click="addBimplusItems">
        Add Item(s)
      </button>
    </div>
    <div class="buttons" v-else>
      <button class="button is-outlined is-danger" @click="$emit('reloadCard')" v-permission="{permissionModule: permissionType,
            type: 'edit', project: card.project}">
        discard changes
      </button>
      <button class="button is-success" @click="save" :disabled="disableSave" v-permission="{permissionModule: permissionType,
            type: 'edit', project: card.project}" >
        save changes
      </button>
      <button
        class="button is-success"
        @click="saveAndMoveNext"
        v-if="!hideSaveAndMoveNext"
        :disabled="isDisabled"
      >
        save &amp; {{ $store.state.activeScreen === 'manager-edit-qa' ? 'create shipment' : 'move forward' }}
      </button>
    </div>
  </footer>
</template>
<script>
import {
  defineComponent,
  reactive,
  computed,
  toRefs,
  inject,
  onBeforeMount,
  onMounted,
  h
} from 'vue';
import { 
  find, 
  get, 
  isEmpty, 
  some,
  cloneDeep,
  keyBy,
  castArray,
  forEach,
  flatMap,
  isFinite,
  every,
  keys,
  isUndefined,
  debounce,
  filter,
  set,
  isNil,
  uniqBy,
  map,
  includes,
  compact,
  has,
} from 'lodash';
import { ModalProgrammatic } from '@oruga-ui/oruga-next';
import MoveOrders from '@/components/modals/MoveOrders.vue';
import CreateShipping from '@/components/modals/CreateShipping.vue';
import { useToast } from 'vue-toastification';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import PrefabsMixin from '@/components/mixins/PrefabsMixin';
import GeneralShippingMixin from '@/components/mixins/GeneralShippingMixin';
import CardEditMixin from '@/components/mixins/CardEditMixin';
import MaterialManager from '@/models/MaterialManager';
import ShippingLabel from '@/models/ShippingLabel';
import Validation from '@/components/utils/Validations';
// import screens from '@/constants';
import PermissionHelper from '@/components/mixins/PermissionHelper';
import Projects from '@/models/Projects';
import SupplyChain from '@/models/SupplyChain';
import Helper from '@/models/Helper';
import { DialogProgrammatic } from '@/components/Dialog';
import Util from '@/components/mixins/UtilityMixin';
import MoveCompletedItems from '@/components/modals/MoveCompletedItems.vue';
import BimPlus from '../../models/BimPlus';
import Validations from '@/utils/Validations';
import MaterialMixin from '@/components/mixins/MaterialMixin';
import BaseOrder from '@/models/BaseOrder'; 

const { isDisabledOnSaveMove, getPermissionModule } = PermissionHelper();

export default defineComponent({
  name: 'card-footer',
  emits: ['changeCard'],
  props: {
    showSave: Boolean,
    card: Object,
    stage: String,
    projectId: String,
    cardId: String,
    type: String,
    buttonPosition: {
      type: String,
      default: '',
    },
    itemQtyChanged: {
      type: Boolean,
      default: false,
    },
    matItemQtyChanged: {
      type: Boolean,
      default: false,
    },
    isNewCard: {
      type: Boolean,
      default: false,
    },
    saveCard: {
      type: Function,
      default: (card) => card,
    },
    addItems: {
      type: Function,
      default: () => {},
    },
    itemObject: Array,
    project: Object,
    createBOM: {
      type: Boolean,
      default: false,
    },
    modelId: {
      type: String,
      default: '',
    },
    isSDS2: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const initialCard = cloneDeep(props.card);
    const toast = useToast();
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const emitter = inject('emitter');
    const { moveToKitLoc, generateShipPdf } = GeneralShippingMixin();
    const { getCardStatus } = CardEditMixin();
    const { createBomAndPR } = PrefabsMixin();
    const {moveFromSourcingToOrderingStage} = MaterialMixin();
    const { conflictHtml } = Util();
    const shippingStages = ['not-started', 'in-transit', 'complete', 'delivery', 'released-to-inventory',
      'fulfilled', 'in-storage', 'mixed-shipping'];

    const state = reactive({
      nextStage: '',
      isMoveForward: true,
      moveFromSourcing: false,
      isSub: false,
      submitMaterial: false,
      selectedValue: true,
      orderForRelease: {},
      showInventoryLoc: false,
      currentLoc: '',
      projectId: '',
      notifyModal: false,
      user: {},
      reservationModalActive: false,
      shipModalActive: false,
      freezeFields: {},
      type: '',
      partialsManagerActive: false,
      masterShipment: null,
      reserveShipmentFor: null,
      isNewPrefab: true,
      obj: [],
      createBomModal: false,
      requiredCheck: [
        { module: 'production-manager', key: 'move' },
        { module: 'production-manager', key: 'data' },
      ],
      moduleMap: {
        'material-edit-ordering': 'material-manager',
        'manager-edit-qa': 'production-manager',
      },
      refreshOrder: false,
      refreshOnClose: false,
      isLoading: false,
      isShippingListVisible: false,
      templateProject: {},
      templateOrders: [],
    });
    const vendorMatchCheck = () => {
      if (isEmpty(props.card.baseDelivery.vendor)) {
        toast.error('Vendor cannot be Empty. Please select a vendor');
        return false;
      }
      // const msg = 'The Order vendor does not match one or more item vendors.
      // do you want to still continue ?';
      let itemVendors = flatMap(compact(map(props.card.items, 'vendors')));
      itemVendors = keyBy(itemVendors, '_id');
      if (
        !isEmpty(itemVendors)
        && !keys(itemVendors).includes(props.card.baseDelivery.vendor._id)
      ) {
        // this.$dialog.confirm({
        //   message: msg,
        //   type: 'is-warning',
        //   hasIcon: true,
        //   size: 'is-medium',
        //   icon: 'exclamation-circle',
        //   iconPack: 'fas',
        //   onCancel: () => {
        //     this.moveFromSourcing = false;
        //   },
        // });
        state.moveFromSourcing = false;
      }
      return true;
    };
    const filterItems = computed(() => filter(props.card.items, (i) => !i.archived.value));
    const planningStage = computed(() => ['coordination', 'detailing', 'manufacturing'].includes(props.card._customStage || props.card.stage));
    const permissionType = computed(() => getPermissionModule(props.card));
    const catItemSync = (cardToSync) => {
      // This fn is created to give user a
      // toast that items name and Id will be in sync with Master CatId Manager.
      if (cardToSync.__t === 'Materials') {
        // eslint-disable-next-line max-len
        const newItem = some(
          cardToSync.items,
          (item) => isUndefined(item._id) && !isEmpty(item.catId),
        );
        if (newItem) {
          toast.warning(
            'Item Name and Id will be in sync with Master Catalog!',
          );
        }
      }
    };
    const bomQtyCheck = async () => {
      let qtyChecked;
      try {
        qtyChecked = await props.card.BOMQuantityCheck();
      } catch (e) {
        console.log(e);
        return toast.warning(e?.message);
      }
      if (['sourcing', 'ordering'].includes(qtyChecked)) {
        return toast.warning('The BOM is in Sourcing/Ordering stage. The quantity changes done here will not be updated in BOM', {
          timeout: 8000,
        });
      }
      if (qtyChecked) {
        return toast.warning('The quantity changes done here will be updated in BOM', {
          timeout: 8000,
        });
      }
      return null;
    };

    const addDefVendor = (orderCard, prevItems) => {
      // add default vendors to the items
      orderCard.items.forEach((item) => {
        const filteredItem = prevItems.filter((prItem) => prItem.uuid === item.uuid);
        if (filteredItem.length) {
          item.defVendor = filteredItem[0].defVendor ? filteredItem[0].defVendor : {};
          item.vendors = filteredItem[0].vendors ? filteredItem[0].vendors : [];
        }
      });
      return orderCard;
    };

    const save = debounce(async () => {
      try {
        state.isLoading = true;
        if (!isEmpty(props.card.customFields)) {
          let isMultiple;
          let isErrorMsg;
          if (props.card.items.length > 0) {
            for (const item of props.card.items) {
              if (!isEmpty(item.customFields)) {
                const isValid = await Validations.validateCustomFields(item.customFields, item, store.state.userData, isMultiple = true, 'po_item', isErrorMsg = true);
                if (!isUndefined(isValid) && !isValid) return;
              }
            }
          }
          const isValid = await Validations.validateCustomFields(props.card.customFields, props.card, store.state.userData, isMultiple = true, 'po_order', isErrorMsg = true);
          if (!isUndefined(isValid) && !isValid) return;
        }
        
        const actualStage = props.card._customStage || route.params.stage;
        const prevItems = props.card.items;
        if (['manager-edit-detailing', 'manager-edit-manufacturing'].includes(store.state.activeScreen) && some(prevItems, (item) => item?.isNew && item?.runs?.length === 0)) {
          throw new Error('Atleast one run should be present in each item');
        }
        
        if (!props.card.isCutOrder && isEmpty(props.card.materials) && some(props.card.catQtyMaps,
            (dt) => parseFloat(dt.qtyToConsume) === 0
              && parseFloat(dt.qtyToShip) === 0
              && !dt.qtyConsumed)){
                throw new Error('Both Qty Consume and Qty ship cannot be 0.');

              }
              
        if (!isEmpty(props.card.materials) && planningStage.value
          && some(props.card.catQtyMaps,
            (dt) => parseFloat(dt.qtyToConsume) === 0
              && parseFloat(dt.qtyToShip) === 0
              && !dt.qtyConsumed)) {
          throw new Error('Both Qty Consume and Qty ship cannot be 0.');
        }

        if (!isEmpty(store.state.reOrderRunsName)) {
          const { runs } = props.card.manager;
          const reOrderRuns = [];
          forEach(store.state.reOrderRunsName, (uuid) => {
            reOrderRuns.push(runs.find((run) => run.uuid === uuid));
          });
          set(props.card, 'manager.runs', reOrderRuns);
        }

        props.card = await getCardStatus(props.card);
        emit('beforeSave');
        catItemSync(props.card);
        // if card is sourcing
        if (['sourcing'].includes(props.card.stage) && isEmpty(props.card.items)) {
          throw new Error('Item Validation failed. Please add an Item to save the Order!');
        }

        // if card is ordering
        if (props.card.stage === 'ordering') {
          if (isUndefined(props.card.baseDelivery.vendor)) {
            throw new Error('Vendor cannot be Empty. Please select a Vendor');
          }
          if (isUndefined(props.card.baseDelivery.recipient)) {
            throw new Error('Please add a Recipient before Shipping');
          }
          props.card.readyForShipment();
        }

        // if card is sourcing or ordering
        if (['sourcing', 'ordering'].includes(props.card.stage) && route.params.cardId === 'add') {
          set(props.card, 'stage', 'preparation');
          state.refreshOrder = true;
        }

        // if card is coordination
        if (props.card.stage === 'coordination' && !isEmpty(props.card.materials) && props.itemQtyChanged === true) {
          await bomQtyCheck();
        }

        if (!isEmpty(props.card.materials) && props.card._bomCreated === true && props.itemQtyChanged === true && !props.card.hasGuid) {
          await bomQtyCheck();
        }

        for (const item of props.card.items) {
          if (!isEmpty(item.measureUnits)
              && !isFinite(parseFloat(item.measure))
          ) {
            throw new Error(`Please select measure for item ${item.name}`);
          }
          if (!isFinite(parseFloat(item.leadTime))) {
            throw new Error(`Lead time cannot be empty for item ${item.name}`);
          }
          if (!isEmpty(item.simpleMemos)) {
            const memo = item.newFTD('memos');
            memo.text = item.simpleMemos[0].text;
          }
        }
        if (filterItems.value.length && props.card.isPrefab() && props.card.purpose === 'kit') {
          const defaultItem = find(filterItems.value, (item) => item.purpose === 'kit');
          set(defaultItem, 'name', props.card.name);
        }
        if (filterItems.value.length === 0 && props.card.__t === 'ProductionOrder') {
          await props.saveCard(props.cardId, props.stage, props.card);
          state.isLoading = false;
          return false;
        }
        if (props.card.isSourcing() && props.card.stage === 'ordering') {
          if (!vendorMatchCheck()) {
            state.isLoading = false;
            return false;
          }
        }
        props.card = await props.saveCard(props.cardId, props.stage, props.card);

        if (props.card.__t === 'Prefabs' && !props.card._id) state.isNewPrefab = false;
        if (
          ['sourcing', 'ordering'].includes(actualStage)
            && route.params.cardId === 'add'
        ) {
          state.isNewPrefab = false;
          const srcCard = (await MaterialManager.pullToSourcing([props.card._id], props.card))[0];
          if (actualStage === 'ordering') {
            await moveFromSourcingToOrderingStage([new BaseOrder(srcCard)]);
          }
          if (route.params.cardId === 'add' && actualStage) {
              setTimeout(() => {
                router.replace({
                  name: 'material-edit',
                  params: {
                    projectId: props.card.project._id,
                    cardId: srcCard._id || srcCard.id,
                    stage: actualStage,
                  },
                });
              }, 2000);
            }
        } else props.card = addDefVendor(props.card, prevItems);

        if (
          route.params.cardId !== 'add'
            && props.card.isMM()
            && actualStage !== 'preparation'
            && some(props.card.items, { stage: 'preparation' })
        ) {
          router.push({
            name: 'material-edit',
            params: {
              projectId: props.card.project._id,
              cardId: props.card._id,
              stage: 'preparation',
            },
          });
          emit('reload-page');
        }
        if (
          props.card.stage === 'preparation'
            && props.card._customStage === 'rejected'
            && (props.card.items.length === 0 || every(props.card.items, { stage: 'preparation' }))
            && route.params.stage === 'rejected'
        ) {
          router.push({
            name: 'material-edit',
            params: {
              projectId: props.card.project._id,
              cardId: props.card._id,
              stage: 'preparation',
            },
          });
          emit('reload-page');
        }
        emit('reload-page');
        state.refreshOrder = false;
      } catch (e) {
        let errMsg = 'Something went wrong, please contact Manufacton Support';
        if (e.message) errMsg = e.message;
        else if (get(e, 'data.msg', '')) errMsg = e.data.msg;
        else if (get(e, 'msg', '')) errMsg = e.msg;
        const conflictMsg = conflictHtml(errMsg);
        // const conflictMsg = `<h3 class="is-size-3 is-italic has-text-weight-bold mb-3 has-text-danger" >Duplicate Order ID:</h3>
        //   <h3 class="is-size-3  mb-3 has-text-danger" > ${errMsg.OrderId}</h3>
        //   <h6 class="is-size-6 has-text-weight-bold has-text-black-bis" >(Order ID's must be unique and cannot be duplicated within a single project.) </h6>
        //   <div class="is-divider my-3"></div>
        //   <h3 class="is-size-3 mb-3 has-text-weight-bold is-italic has-text-black-bis" >Order Name:</h3>
        //   <h3 class="is-size-3 mb-3 has-text-black-bis" >${errMsg.OrderName} </h3>
        //    <h3 class="is-size-3 mb-3 has-text-weight-bold is-italic has-text-black-bis" >Project: </h3>
        //    <h3 class="is-size-3 has-text-black-bis" >${errMsg.Project} </h3>`;
        if (errMsg.OrderId || errMsg.OrderName || errMsg.Project) {
          const confirmParam = {
            title: 'CONFLICT: Order ID',
            okButton: 'Close',
            type: 'black-bis',
            conflictNote: conflictMsg,
            noteType: 'danger',
          };
          DialogProgrammatic.confirm(confirmParam);
        } else {
          toast.error(h('div', {innerHTML: errMsg}));
        }
      } finally {
        state.isLoading = false;
      }
      return null;
    },
    1000,
    { leading: true, trailing: false });

    const showListView = (goBack = false) => {
      let path = '/home';
      goBack = !!props.card._id;
      if (['sourcing', 'ordering', ...shippingStages].includes(props.card.stage)
        && ['Materials', 'Sourcing'].includes(props.card.__t)) {
        goBack = false;
      }
      if (window.history.length > 1 && goBack) {
        router.go(-1);
        return;
      }
      if (props.card.isPM()) {
        if ([...shippingStages, 'mixed'].includes(props.card._customStage)) {
          path = '/manager/detailing';
        } else path = `/manager/${props.card._customStage}`;
      } else if (props.card.isMM()) {
        if ([...shippingStages, 'mixed', 'rejected'].includes(props.card._customStage)) {
          path = '/materials/preparation';
        } else path = `/materials/${props.card._customStage}`;
      } else if (props.card.isPrefab()) {
        path = '/prefab/planning';
      } else if (props.card.isPO()) {
        path = '/prefab/coordination';
      } else if (props.card.isSourcing()) {
        if (shippingStages.includes(props.card.stage)) path = '/materials/ordering';
        else path = `/materials/${props.card.stage}`;
      }
      router.push({ path });
    };

    const moveCardToNextStage = (cardToMove) => {
      const cardData = castArray(cardToMove);
      const cardWithNoItems = cardData.filter((cD) => !cD.items.length);
      if (cardWithNoItems.length) {
        toast.error('Can not move selected orders, no items found');
      } else {
        // toggle modal
        ModalProgrammatic.open({
          component: MoveOrders,
          props: {
            type: props.type,
            cards: cardData,
            isActive: true,
            isMulti: false,
            kind: 'forward',
            templateProj: state.templateProject,
            templateOrders: state.templateOrders,
            initialCard,
            isCutOrder: cardToMove.isCutOrder,
            itemsCount: cardToMove.numberOfItems,
          },
          events: {
            close: (moved) => {
              if (moved) {
                showListView();
              } else {
                emit('reload-page');
              }
            },
          },
          canCancel: false,
          rootClass: store.state.activeScreen === 'material-edit-sourcing'
            ? 'modal-md' : 'modal-sm',
        });
      }
    };

    const checkOrderStatus = () => {
      if (props.card._customStage === 'manufacturing' && props.card.status === 'pause') {
        toast.error('Order is paused, cannot move to next stage');
        state.isLoading = false;
      }
      return !(props.card._customStage === 'manufacturing' && props.card.status === 'pause');
    };

    // save and move forward
    const saveAndMoveNext = debounce(async () => {
      state.isLoading = true;
      if (!props.card) emit('reload-page');
      if (!isEmpty(props.card.customFields)) {
        let isMultiple;
        const isValid = await Validations.validateCustomFields(props.card.customFields, props.card, store.state.userData, isMultiple = true, 'po_order');
        if (!isUndefined(isValid) && !isValid) return;
      }
      catItemSync(props.card);
      if (['sourcing', 'ordering'].includes(props.card.stage) && route.params.cardId === 'add') {
        props.card = await props.saveCard(props.cardId, props.stage, props.card);
        const srcCard = (await MaterialManager.pullToSourcing([props.card._id]))[0];
        emit('changeCard', srcCard);
      }
      if (!isEmpty(props.card.materials) && props.card._bomCreated === true
       && props.itemQtyChanged === true && !props.card.hasGuid) {
        await bomQtyCheck();
      }
      if (props.card.stage === 'sourcing') {
        state.isLoading = false;
        if (some(props.card.items, (item) => !Validation.validateCatalogId(item.catId))) {
          toast.error('Catalog ID should be 4 to 32 character long');
          return;
        }
        if (!vendorMatchCheck()) {
          return;
        }
        if (isEmpty(props.card.baseDelivery.recipient)) {
          toast.error('Recipient is mandatory');
          return;
        }
        if (isEmpty(props.card.baseDelivery.location)) {
          toast.error('Delivery location cannot be Empty. Please select a delivery location');
          return;
        }
        if (props.card.items && props.card.items.length > 50) {
          toast.error(`Too many items to move this order.
           Please break it down into orders of 50 items or less, and then move.`);
          return;
        }
      }
      for (const item of props.card.items) {
        if (!isEmpty(item.measureUnits)
            && !isFinite(parseFloat(item.measure))
        ) {
          toast.error(`Please select measure for item ${item.name}`);
          state.isLoading = false;
          return;
        }
        if (!isFinite(parseFloat(item.leadTime))) {
          toast.error(
            `Lead time cannot be empty for item ${item.name}`,
          );
        }
        if (!isEmpty(item.simpleMemos)) {
          const memo = item.newFTD('memos');
          memo.text = item.simpleMemos[0].text;
        }
      }
      if (!checkOrderStatus()) return;
      if (props.card._customStage === 'manufacturing') {
        const shipMaterials = await props.card.materialsReadyToShip();
        if (!shipMaterials) {
          toast.error('Some of the materials are not reserved. Please reserve before moving.');
          state.isLoading = false;
          return;
        }
      }
      if (props.card._customStage === 'manufacturing' && get(props.card, 'purpose') === 'kit'
          && props.card.isLocked) {
        toast.error('Some Kit components are still in Manufacturing. Please advance them out of manufacturing and Try again');
        state.isLoading = false;
        return;
      }
      // if (card._customStage === 'manufacturing') {
      //   const shipMaterials = await card.materialsReadyToShip();
      //   if (!shipMaterials) {
      //     toast.error('Some of the materials are not reserved. Please reserve before moving.');
      //     state.isLoading = false;
      //     return;
      //   }
      // }
      if (['coordination', 'detailing'].includes(props.card.stage)) {
        if (some(props.card.catQtyMaps, (dt) => parseFloat(dt.qtyToConsume) === 0
        && parseFloat(dt.qtyToShip) === 0 && !dt.qtyConsumed)) {
          toast.warning('Both Qty Consume and Qty ship cannot be 0.');
          state.isLoading = false;
          return;
        }
      }
      if (props.card.isPrefab() && props.card.purpose === 'kit') {
        const defaultItem = find(props.card.items, (item) => item.purpose === 'kit');
        set(defaultItem, 'name', props.card.name);
      }
      props.card = await getCardStatus(props.card);
      try {
        if (props.card.__t === 'Prefabs' && !props.card._id) state.isNewPrefab = false;
        if (props.card.isPrefab() || props.card.isMM()) {
          props.card = await props.saveCard(props.cardId, props.stage, props.card);
        } else if (props.card._customStage === 'qa') {
          props.card = await props.saveCard(props.cardId, props.stage, props.card);
          if (isCreateShipping) return createShipmentModal(props.card);
        } else {
          props.card = await props.saveCard(props.cardId, props.stage, props.card);
        }
        // handle bom and pick request creation
        const isDetail = some(props.card.items, (item) => ['detailing', 'coordination'].includes(item.stage));
        if (isDetail) props.card = await createBomAndPR(props.card);
        emit('change-qty-flag');
        moveCardToNextStage(props.card);
      } catch (e) {
        toast.error(e.data ? e.data.msg : null || e.message || e.msg || 'Something went wrong, please contact Manufacton Support');
      } finally {
        state.isLoading = false;
      }
    }, 1000, { leading: true, trailing: false });

    onBeforeMount(async () => {
      const stageMap = {
        materials: ['preparation', 'sourcing', 'ordering'],
        productionOrder: [
          'prefab',
          'po',
          'detailing',
          'manufacturing',
          'qa',
        ],
      };
      const stages = stageMap[
        ['Materials', 'Sourcing'].includes(props.card.__t)
          ? 'materials'
          : 'productionOrder'
      ];
      let curStage = props.type.split('-');
      curStage = curStage.length === 2 ? curStage[0] : curStage[curStage.length - 1];
      let curIdx = stages.indexOf(curStage);
      if (curIdx === stages.length - 1) {
        state.nextStage = 'shipping';
        return;
      }
      state.nextStage = stages[++curIdx];
      if (props.card.stage === state.nextStage) {
        state.nextStage = stages[++curIdx];
      }
      if (store.state.activeScreen === 'prefab-edit') {
        ({ templateProject: state.templateProject } = (await Projects.haveTemplateProject()));
        state.templateOrders = await SupplyChain.supplyChain({
          projectId: state.templateProject._id,
          module: 'ProdTemplates',
          filterNoItemOrders: false,
          limit: 9999,
          page: 1,
        });
      }
    });
    onMounted(async () => {
      await store.getters.userPromise;
      state.user = store.state.userData;
    });

    const createShipmentModal = async (cardData) => {
      state.isLoading = true;
      const inventoryItems = ['qa'].includes(cardData._customStage) ? await Helper.getMaterialItems(cardData) : [];
      if (some(inventoryItems?.data, (item) => isUndefined(item.reserved)) && ['qa'].includes(cardData._customStage)) {
        const catIds = cardData.reqForReserveQty(inventoryItems);
        await cardData.reserveCatalog(catIds, store.state.userData);
      }
      if (!checkOrderStatus()) return;
      if (cardData._customStage === 'manufacturing') {
        const shipMaterials = await cardData.materialsReadyToShip();
        if (!shipMaterials) {
          toast.error('Some of the materials are not reserved. Please reserve before moving.');
          state.isLoading = false;
          return;
        }
      }
      if (cardData._customStage === 'manufacturing' && get(cardData, 'purpose') === 'kit'
          && cardData.isLocked) {
        toast.error('Some Kit components are still in Manufacturing. Please advance them out of manufacturing and Try again');
        state.isLoading = false;
        return;
      }
      ModalProgrammatic.open({
        component: CreateShipping,
        props: {
          orders: [cardData],
        },
        events: {
          close: (moved) => {
            if (moved) {
              let currentURL = window.location.href;
              let redirect = "";
              if (currentURL.includes("manufacturing")) {
                redirect = "/manager/manufacturing";
              } else if(currentURL.includes("qa")) {
                redirect = "/manager/qa";
              }
              if (!isUndefined(redirect)) {
                router.push({ path: `${redirect}` });
              }
            }
          },
        },
        canCancel: false,
        rootClass: 'modal-sm',
      });
      state.isLoading = false;
    };

    const moveToKit = (async (kitCard) => {
      state.isLoading = true;
      await moveToKitLoc(kitCard, props.saveCard);
      showListView();
      state.isLoading = false;
    });

    const moveItemsToInventory = async () => {
      try {
        state.isLoading = true;
        if(!checkOrderStatus()) return;
        if (props.card._customStage === 'manufacturing' && props.card?.isCutOrder) {
          const someUnreserved = some(props.card.catQtyMaps, (item) => {
            const totalQtyToProcess = (item.qtyToConsume + item.qtyToShip + item.qtyToReturn);
            if (item.qtyReserved < totalQtyToProcess) {
              toast.error('Some of the materials are not reserved. Please reserve before moving.');
              return true;
            }
            return false;
          });

          if (someUnreserved) {
            return;
          }
        }


        ModalProgrammatic.open({
          component: MoveCompletedItems,
          props: {
            card: props.card,
          },
          events: {
            close: (moved) => {
              if (moved) {
                let currentURL = window.location.href;
                let redirect = "";

                if (currentURL.includes("manufacturing")) {
                  redirect = "/manager/manufacturing";
                } else if(currentURL.includes("qa")) {
                  redirect = "/manager/qa";
                }

                if (!isUndefined(redirect)) {
                  router.push({ path: `${redirect}` });
                }
              }
            },
          },
          canCancel: false,
          rootClass: 'modal-sm',
        })

      } catch (error) {
        console.error(error.message);
      } finally {
        state.isLoading = false;
      }
    };

    const hideSaveAndMoveNext = computed(() => {
      if (props.card.isCutOrder && ['manufacturing', 'mixed'].includes(props.card.stage) && props.card.isDirty) return true;
      if (props.card.__t === 'Prefabs' && props.card._customStage === 'planning') {
        return !some(props.card.items, { stage: 'planning' });
      }
      if (props.card.__t === 'Materials') return !some(props.card.items, { stage: 'preparation' });
      return ['ordering', ...shippingStages].includes(props.card._customStage);
    });

    const isCreateShipping = computed(() => {
      if (store.state.activeScreen === 'manager-edit-detailing') return false;
      if (props.card.__t === 'ProductionOrder' && some(props.card.items, (item) => ['manufacturing', 'qa'].includes(item.stage))
       && props.card.purpose !== 'assembly') {
        return true;
      }
      return false;
    });

    const isAssembly = computed(() => {
      if (props.card.__t === 'ProductionOrder' && ['manufacturing', 'qa'].includes(props.card.stage)
      && props.card.purpose === 'assembly') {
        return true;
      }
      return false;
    });

    const moveButtonName = computed(() => {
      const buttonTextObj = {
        planning: 'Create Orders In Coordination',
        sourcing: 'Create Purchase Order',
        manufacturing: 'Move To QA/QC',
      };
      if (buttonTextObj[props.card.stage]) return buttonTextObj[props.card.stage];
      if (state.nextStage === 'po') return 'Create Orders In Coordination';
      return `Move Order to ${state.nextStage}`;
    });

    const isShippingDisabled = computed(() => {
      if (props.card.status === 'pause') return true;
      if (props.stage === 'qa') {
        if (isDisabledOnSaveMove(props.card)) return true;
        return false;
      };
      if (some(get(props.card, 'items', []), (item) => item.isCompleted)) return false;
      return (!some(get(props.card, 'manager.itemStatus', []), (item, key) => item.done && !find(get(props.card, 'items', []), (itm) => itm._id === key)?.markCompleteDisabled));
    });

    const isItemsCompleted = computed(() => {
      if (some(props.card.items, (i) => i.isCompleted === true)) return true;
      return some(props.card.items, (i) => i.isItemCompleted === true); // we have to change it back to isCompleted
    });

    // const getType = computed(() => {
    //   const res = _.get(screens[store.state.activeScreen], 'moduleKey', '');
    //   return res;
    // });

    const disableSave =computed(() => {
      if (props.card.owner.company._id !== store.state.userData.company) {
        return true;
      }
    })

    const disableSaveAndMove = computed(() => {
      const project = store.getters.findProject({ _id: props.card.project._id });
      if (project?.isTemplateProject
        && ['manufacturing', 'ordering'].includes(props.card._customStage)) return true;
      if (!filterItems.value.length) return true;
      if (props.card._customStage === 'planning') {
        return !some(props.card.items, { stage: 'planning' });
      }
      if (props.card._customStage === 'coordination') {
        return (props.card.owner.company._id !== state.user.company);
      }
      if (props.card.__t === 'Materials' && some(props.card.items, ['stage', 'rejected'])) {
        return false;
      }
      if (props.card.__t === 'Materials' && some(props.card.items, (item) => ['preparation', 'rejected'].includes(item.stage) && has(item, 'purchase') && item.purchase) && get(route, 'params.stage', '') === 'sourcing') return true;
      if (props.card.__t === 'Materials' && !some(props.card.items, (item) => ['preparation', 'rejected'].includes(item.stage) && (!has(item, 'purchase') || item?.purchase))) return true;
      if (props.card.stage === 'ordering') return false;
      if (props.card.__t === 'Materials' && props.card.stage !== 'preparation') return false;
      return shippingStages.includes(props.card._customStage);
    });

    const allowRejectedMove = computed(() => {
      if (store.state.activeScreen === 'material-edit-preparation' && props.stage === 'rejected') {
        return every(props.card.items, (item) => item.stage === props.stage);
      }
      if (store.state.activeScreen === 'material-edit-sourcing') {
        return some(props.card.items, (item) => item.stage === 'rejected');
      }
      return false;
    });

    const isDisabled = computed(() => {
      if (props.card.owner.company._id !== store.state.userData.company) {
        return true;
      }
      if (props.card.stage === 'manufacturing') {
        return isShippingDisabled.value;
      }
      if (props.card.status === 'pause') return true;
      return !props.card.items.length || allowRejectedMove.value
      || (!some(props.card.items, (item) => item.stage === props.stage))
      || disableSaveAndMove.value || isDisabledOnSaveMove(props.card);
    });

    onBeforeMount(async () => {
      if (isEmpty(store.state.userData?.company)) {
        await store.dispatch('getUserData');
      }
    });
    emitter.on('onFormSave', async (payload) => {
      await save();
      setTimeout(() => {
        router.go(0);
      }, 200);
    });

    const addBimplusItems = async () => {
      if (some(props.itemObject, (item) => isEmpty(item.name)) || some(props.itemObject, (item) => item.name.length < 2)) {
        toast.error('Item names must be at least 2 characters long. Please provide valid names before proceeding.');
        return;
      }
      try {
        if (props.isSDS2) await BimPlus.addAssemblyParts(props.itemObject);
        if (isEmpty(props.card.modelId)) props.card.modelId = props.modelId;
                
        await props.addItems();
        await save();
        let guidList = [];
        if (!isEmpty(props.itemObject)) {
          for (let item of props.itemObject) {
            let newItem = find(props.card.items, (i) => i.identifier === item.identifier || i.name === item.name );
            if (item.guids) {
              for (let guid of item.guids) {
                guid.uuid = newItem.uuid;
                guidList.push(guid);
              }
            }
            if (!isEmpty(item.materials)) {
              item.materials.forEach((material) => {
                if (material.guids) {
                  for (let guid of material.guids) {
                    guid.uuid = newItem.uuid;
                    guidList.push(guid);
                  }
                }
              });
            }
          }
        }
        
        await BimPlus.addBimplusElements({
          order: props.card,
          guidList,
          access_token: store.state.bimplus.access_token,
          team_slug: get(props.project, 'projectSettings[0].bimplusSync.team.id', ''),
          bimProjectId: get(props.project, 'projectSettings[0].bimplusSync.project.id', ''),
        });
        if (props.createBOM) await BimPlus.createBOM({
          newCard: props.card,
          bimplusItems: props.itemObject,
          fetchOrder: true,
        });
      } catch (error) {
        console.log('Error:', error);
      } finally {
        router.push({
          name: `manager-edit`,
          params: {
            projectId: props.projectId,
            cardId: props.cardId,
            stage: 'detailing',
          },
        });
      }
    }

    return {
      ...toRefs(state),
      save,
      saveAndMoveNext,
      hideSaveAndMoveNext,
      isCreateShipping,
      createShipmentModal,
      isDisabled,
      isAssembly,
      moveToKit,
      moveButtonName,
      isShippingDisabled,
      permissionType,
      disableSave,
      moveItemsToInventory,
      isItemsCompleted,
      addBimplusItems,
    };
  },
});
</script>
